import React, { useEffect, useState } from 'react'
import { FaBirthdayCake } from 'react-icons/fa';
import Confetti from 'react-confetti';
import { fetchAllDataAPI } from '../../utils/api';
import withAuth from '../../utils/withAuth';
import { BASEEMPURLS } from '../../utils/BaseUrl';

const TodayBirthday = () => {
    const [tbirthday, setTbirthday] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getTodayBirthday();
    }, []);

    const getTodayBirthday = () => {
        setIsLoading(true);
        fetchAllDataAPI('hr-all-today-birthday').then((res) => {
            if (res.data.status === 1) {
                setTbirthday(res.data.tbirthday || []);
            } else {
                setTbirthday([]);
            }
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        });
    }

    const renderSkeleton = () => {
        return Array(3).fill(0).map((_, index) => (
            <div className="todaybirthday border-top" key={index}>
                <div className="todaybirthdayimgname mt-2 d-flex align-items-center">
                    <div className="todaybirthdayimg">
                        <div className="skeleton skeleton-avatar"></div>
                    </div>
                    <div className="ms-2 todaybirthdayname">
                        <div className="skeleton skeleton-text w-75 mb-2"></div>
                        <div className="skeleton skeleton-text w-50"></div>
                    </div>
                </div>
            </div>
        ));
    }

    const renderNoDataFound = () => {
        return (
            <div className="text-center py-4">
                <p className="text-secondary mb-0">🎂 No Birthdays Today!</p>
            </div>
        );
    }

    return (
        <div className="card radius-10 overflow-hidden w-100 topsection birthdaysectioncard">
            <Confetti />
            <div className="d-flex align-items-center">
                <div>
                    <h5 className="mb-0">Today's Birthday</h5>
                </div>
            </div>

            <div className="p-2 birthdaysection bodysection">
                {isLoading ? (
                    renderSkeleton()
                ) : (
                    tbirthday.length > 0 ? (
                        tbirthday.map((item, index) => (
                            <div className="todaybirthday border-top" key={index}>
                                <div className="todaybirthdayimgname mt-2 d-flex align-items-center">
                                    <div className="todaybirthdayimg">
                                        <img src={BASEEMPURLS(item.emp_foto)} className="rounded-circle" alt="employee" />
                                    </div>
                                    <div className="ms-2 todaybirthdayname">
                                        <h3 className="mb-1 font-14"><FaBirthdayCake /> {item.emp_name}</h3>
                                        <p className="mb-0 font-5 text-secondary">{item.emp_job_role}</p>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        renderNoDataFound()
                    )
                )}
            </div>

            {/* Skeleton Style */}
            <style jsx="true">{`
                .skeleton {
                    background-color: #e2e2e2;
                    border-radius: 4px;
                    animation: shimmer 1.5s infinite linear;
                }
                .skeleton-avatar {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                }
                .skeleton-text {
                    height: 12px;
                    margin-bottom: 8px;
                    border-radius: 4px;
                }
                @keyframes shimmer {
                    0% { background-position: -400px 0; }
                    100% { background-position: 400px 0; }
                }
            `}</style>
        </div>
    )
}

export default withAuth(TodayBirthday)
